import { defineSlotRecipe } from '@chakra-ui/react';

import { blockElementSlots } from '../slots';

export default defineSlotRecipe({
  slots: blockElementSlots,
  variants: {
    variant: {
      plain: {},
      'plain-slim': {},
    },
  },
});
